
export class CritereRechercheValue {

    crv_id: string;
    crv_crr_id: string;
    crv_parent_id: string;
    crv_libelle: string;
    crv_value: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.crv_id             = data['crv_id'] ? data['crv_id'] : null;
        this.crv_crr_id         = data['crv_crr_id'] ? data['crv_crr_id'] : null;
        this.crv_parent_id      = data['crv_parent_id'] ? data['crv_parent_id'] : null;
        this.crv_libelle        = data['crv_libelle'] ? data['crv_libelle'] : null;
        this.crv_value          = data['crv_value'] ? data['crv_value'] : null;
    }

}
